import React from 'react';

const Baseball: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="inline-flex items-center gap-2 rounded-full border border-slate-700/70 bg-slate-900/60 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-300">
        Baseball
        <span className="h-1 w-6 rounded-full bg-gradient-to-r from-emerald-400 via-amber-300 to-red-400" />
      </div>
      <div className="grid gap-8 md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:items-start">
        <div className="space-y-4 text-sm leading-relaxed text-slate-200">
          <p>
            Before I was shipping software, I was competing on the field. I played Division I baseball at the University
            of the Pacific as a first baseman and outfielder, starting early in my career and finishing as a redshirt
            senior.
          </p>
          <p>
            That experience shaped how I approach engineering: preparation, communication, and showing up in high-leverage
            moments. Building systems for live sports and broadcast is a natural extension of that background—different
            tools, same intensity.
          </p>
        </div>
        <div className="space-y-4 rounded-2xl border border-slate-800/80 bg-slate-900/60 p-5 text-xs text-slate-200">
          <h3 className="text-sm font-semibold text-slate-50">Baseball links</h3>
          <ul className="space-y-2">
            <li>
              <a
                href="https://pacifictigers.com/sports/baseball/roster/nate-verlin/661"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center text-[11px] font-semibold uppercase tracking-[0.2em] text-emerald-300 hover:text-emerald-200"
              >
                Pacific Tigers Roster
                <span className="ml-1 text-[13px]">↗</span>
              </a>
            </li>
            <li>
              <a
                href="https://www.baseball-reference.com/register/player.fcgi?id=verlin000nat"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center text-[11px] font-semibold uppercase tracking-[0.2em] text-emerald-300 hover:text-emerald-200"
              >
                Baseball-Reference Profile
                <span className="ml-1 text-[13px]">↗</span>
              </a>
            </li>
          </ul>
          <p className="text-[11px] text-slate-400">
            Over five college seasons and summer leagues, I logged more than 190 games and 220+ hits across NCAA and
            independent competition, primarily as a left-handed first baseman and corner outfielder.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Baseball;

